import React from "react";

export default function ECLGaugeRichText(props) {
   const width =
      (parseFloat(props.currentVal) / parseFloat(props.maxVal)) * 100;
   return (
      <div className="ecl-gauge">
         <div className="gauge-labels-div">
            <p className="gauge-label left">{props.leftLabel}</p>
            <p className="gauge-label right">{props.rightLabel}</p>
         </div>
         <div className="gauge-values-div">
            <h3
               className={
                  width >= 100
                     ? "gauge-value full-gauge-text"
                     : "gauge-value left"
               }
            >
               {props.currentVal}
            </h3>
            <h3
               className={
                  width >= 100 ? "gauge-value full-gauge-text" : "gauge-value"
               }
            >
               {props.maxVal}
            </h3>
         </div>
         <div className="gauge-container">
            <div className="total-gauge"></div>
            <div
               className={
                  width >= 100 ? "value-gauge full-gauge" : "value-gauge"
               }
               style={{ width: `${width}%` }}
            ></div>
         </div>
      </div>
   );
}
